// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-3CHg","left":"styles_left__1wP7B"};